export class ApiError extends Error {
  readonly code: number;
  constructor(code: number, message?: string) {
    super(message);
    this.code = code;
  }
}

export class NetworkError extends Error {}

export class ResetError extends Error {}
